import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { Dimension } from '@upright/common/model/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { NetImpactLensOptions } from '@upright/ui/common/upright/core/impact-lenses/net-impact/types';
import { plusIfPositive } from '@upright/ui/common/upright/model/output/scores/net-impact-chart/shared';
import { formatImpactScore } from '@upright/ui/common/upright/model/output/scores/net-impact-chart/value-formatter';
import { isNil } from 'lodash';

interface Props {
  dimension: Dimension;
}

export function DimensionTitleNetFigure(props: Props) {
  const { dimension } = props;

  // little bit ugly casting here, may wish to rework later on
  const ctx = useCarouselContext<ImpactLensType.UPRIGHT_NET_IMPACT>();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ctx.lensType !== ImpactLensType.UPRIGHT_NET_IMPACT) {
    return <></>;
  }

  const options = ctx.options as NetImpactLensOptions;
  const selection = ctx.selectionState;

  const value = options.scoreReader.readScore(undefined, dimension, undefined, undefined);
  if (isNil(value) || !selection.showAllNetFigures || !selection.showDimensionBars) {
    return <></>;
  }
  const formatted = formatImpactScore(value, options.formatters, options.scoreUnit);
  const roundedValue = parseFloat(formatted);
  const color =
    roundedValue > 0
      ? BouColor.IMPACT_POSITIVE_GREEN
      : roundedValue < 0
        ? BouColor.IMPACT_NEGATIVE_PURPLE
        : BouColor.IMPACT_NEUTRAL_GRAY;

  return (
    <tspan fill={color}>
      &nbsp;
      {plusIfPositive(value)}
      {formatted}
    </tspan>
  );
}
